// ==================== CONSTANTS ====================
export const ROLE_HIERARCHY = {
  "Super-User": 1,
  "Game-Owner": 2,
  "Master-Distributor": 3,
  Distributor: 4,
  "Sub-Distributor": 5,
  Agent: 6,
  Player: 7,
};

export const COLORS = {
  "Super-User": "#9c27b0",
  "Game-Owner": "#f44336",
  "Master-Distributor": "#ff9800",
  Distributor: "#2196f3",
  "Sub-Distributor": "#4caf50",
  Agent: "#607d8b",
};

// ==================== STYLES ====================
export const inputSx = {
  "& .MuiOutlinedInput-root": {
    color: "#fff",
    bgcolor: "rgba(255,255,255,0.05)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.23)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.4)" },
    "&.Mui-focused fieldset": { borderColor: "#0288d1" },
  },
  "& .MuiInputBase-input::placeholder": {
    color: "rgba(255,255,255,0.5)",
    opacity: 1,
  },
};

export const filterInputSx = {
  "& .MuiOutlinedInput-root": {
    color: "#fff",
    bgcolor: "rgba(255,255,255,0.08)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.3)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.5)" },
    "&.Mui-focused fieldset": { borderColor: "#0288d1" },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.7)",
    "&.Mui-focused": { color: "#0288d1" },
  },
  "& .MuiInputBase-input": {
    color: "#fff",
  },
  "& select": {
    color: "#fff",
  },
  "& option": {
    bgcolor: "#2a2a2a",
    color: "#fff",
  },
};

// ==================== HELPER FUNCTIONS ====================
export const canMessageUser = (senderRole, receiverRole) => {
  if (senderRole === "Super-User") return { allowed: true };
  if (receiverRole === "Super-User") return { allowed: false, reason: "Cannot message Super User" };
  if (senderRole === "Player" || receiverRole === "Player") {
    return { allowed: false, reason: "Players cannot use the messaging system" };
  }
  const senderLevel = ROLE_HIERARCHY[senderRole];
  const receiverLevel = ROLE_HIERARCHY[receiverRole];
  if (!senderLevel || !receiverLevel) return { allowed: false, reason: "Invalid role" };
  const levelDifference = Math.abs(senderLevel - receiverLevel);
  if (levelDifference === 1) return { allowed: true };
  return { allowed: false, reason: "Can only message users one level above or below" };
};

export const formatTime = (d) => {
  if (!d) return "";
  const diff = Date.now() - new Date(d);
  if (diff < 60000) return "Just now";
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m`;
  if (diff < 86400000)
    return new Date(d).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
